import {
  type Appointment,
  type ConfirmModalDefinition,
  type ConsentModalDefinition,
  type Customer,
  type CustomerModalDefinition,
  type CustomerProfileModalDefinition,
  type NewProjectModalDefinition,
  type SelectCoworkerAndTeamModalDefinition,
  type SelectDepartmentModalDefinition,
  type Task,
  type hfb,
  resetCustomerProfile,
} from "@repo/api";

export const openNewProjectModal = ({
  onSelectProject,
  onProjectCreated,
  pushModal,
  resetModal,
  initialCustomerSearchValue,
  associatedTask,
  associatedDropInAppointment,
  customerInfo,
  departments,
  filterCurrentProject,
}: {
  onSelectProject: (projectId: number) => void;
  onProjectCreated: (projectId: number) => void;
  pushModal: (
    modalProps:
      | SelectDepartmentModalDefinition
      | SelectCoworkerAndTeamModalDefinition
      | ConsentModalDefinition
      | CustomerModalDefinition
      | ConfirmModalDefinition
      | CustomerProfileModalDefinition
      | NewProjectModalDefinition,
    reset?: boolean
  ) => void;
  resetModal?: boolean;
  initialCustomerSearchValue?: string;
  associatedTask?: Task;
  associatedDropInAppointment?: Appointment;
  customerInfo?: Customer;
  departments?: hfb[];
  filterCurrentProject?: number;
}) => {
  if (!customerInfo) {
    pushModal({
      type: "CUSTOMER_PROFILE",
      pushModal,
      associatedDropInAppointment,
      associatedTask,
      initialCustomerSearchValue,
      departments,
    });
    resetCustomerProfile();
  } else {
    pushModal(
      {
        type: "NEW_PROJECT",
        pushModal,
        onProjectCreated,
        onSelectProject,
        associatedDropInAppointment,
        associatedTask,
        initialCustomerSearchValue,
        customerInfo,
        departments,
        filterCurrentProject,
      },
      resetModal
    );
  }
};
